// PanelRoutes.jsx
import { Routes as RouterRoutes, Route } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import ProtectedRoute from "./components/ProtectedRoutes";
import DentalShop from "./pages/DlaShop/DlaShopTitles";
import ProductsPage from "./pages/DlaShop/ProductsPage";
import AllProductsPage from "./pages/DlaShop/AllProductsPage"; // This is the import that was missing
import AddCardPage from "./pages/AddCardPage";
import EditCardPage from "./pages/EditCardPage";
import Members from "./pages/members/Members";
import Home from "./pages/Home";
import AboutDla from "./pages/AboutDla";
import WorkWeDo from "./pages/WorkWeDo";
import MeetTheBoard from "./pages/Aboutpages/MeettheBoard";
import ReasonstoJoin from "./pages/Aboutpages/ReasonstoJoin";
import DLAFellowship from "./pages/Aboutpages/DLAFellowship";
import EducationPage from "./pages/Education";
import RegulationPage from "./pages/Regulation";
import MembershipSupport from "./pages/MembershipSupport";
import HeadlineSponsor from "./pages/DLAtrade/DLAheadlineSponser";
import SponsorshipOpportunity from "./pages/DLAtrade/SponsorshipOppurtunity";
import TradeAwards from "./pages/DLAtrade/DLAtradeawards";
import OurPolicies from "./pages/OurPolicy";
import PolicyDetail from "./pages/PolicyDetail";
import ItemDetail from "./pages/ItemDetail";
import AZDirectory from "./pages/DLAtrade/AffiliateMembers";
import BecomeAffiliateMember from "./pages/DLAtrade/BecomeAffiliateMember";
import BecomeAMember from "./pages/Aboutpages/BecomeAMember";
import ContentDetailPage from "./pages/Aboutpages/ContentDetailPage";
import FellowshipAwards from "./pages/Aboutpages/FellowShipAwards"; // ✅ NEW IMPORT
import SpecialRecognitionAward from "./pages/Aboutpages/SpecialRecognitionAward";
import DentalNews from "./pages/DLANews/DentalNews";
import DlaNewsPosts from "./pages/DLANews/DlaNewsPosts";
import DentallabJournal from "./pages/DLANews/DentalLabJournal";
import AddStoreCards from "./pages/Store/AddStorecards";
import MembersAreaCards from "./pages/members/MembersAreaPage";
import DRAPApplicationsPage from "./pages/members/DRAPApplicationsPage";

const PanelRoutes = () => {
  return (
    <div className="flex">
      <Sidebar />
      <div className="flex-1">
        <RouterRoutes>
          {/* Main DLA Shop Dashboard */}
          <Route path="/home" element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          } />

          <Route path="/dla-shop" element={
            <ProtectedRoute>
              <DentalShop />
            </ProtectedRoute>
          } />

          {/* Products Page with Category ID */}
          <Route path="/dla-shop/:categoryId" element={
            <ProtectedRoute>
              <ProductsPage />
            </ProtectedRoute>
          } />

          {/* All Products Page - THIS IS THE KEY ROUTE */}
          <Route path="/dla-shop/all-products" element={
            <ProtectedRoute>
              <AllProductsPage />
            </ProtectedRoute>
          } />

          {/* Add Card Page */}
          <Route path="/add-card" element={
            <ProtectedRoute>
              <AddCardPage />
            </ProtectedRoute>
          } />

          {/* Edit Card Page */}
          <Route path="/edit-card/:id" element={
            <ProtectedRoute>
              <EditCardPage />
            </ProtectedRoute>
          } />
          
          <Route path="/About-Dla" element={
            <ProtectedRoute>
              <AboutDla />
            </ProtectedRoute>
          } />
          
          <Route path="/About-Dla/MeettheBoard" element={
            <ProtectedRoute>
              <MeetTheBoard />
            </ProtectedRoute>
          } />

         <Route path="/About-Dla/WorkWeDo" element={
            <ProtectedRoute>
              <WorkWeDo />
            </ProtectedRoute>
          } />
          
          <Route path="/About-Dla/WorkWeDo/Education" element={
            <ProtectedRoute>
              <EducationPage />
            </ProtectedRoute>
          } />

           <Route path="/About-Dla/WorkWeDo/Regulation" element={
            <ProtectedRoute>
              <RegulationPage />
            </ProtectedRoute>
          } />
           
           <Route path="/About-Dla/WorkWeDo/Support" element={
            <ProtectedRoute>
              <MembershipSupport />
            </ProtectedRoute>
          } />

          {/* Existing Members Page */}
          <Route path="/add-members" element={
            <ProtectedRoute>
              <Members />
            </ProtectedRoute>
          } />
          
          <Route path="/About-Dla/BecomeMember/Reasons" element={
            <ProtectedRoute>
              <ReasonstoJoin />
            </ProtectedRoute>
          } />
          
          <Route path="/About-Dla/DLAFellowship" element={
            <ProtectedRoute>
              <DLAFellowship />
            </ProtectedRoute>
          } />
          
          <Route path="/DlaTrade/headline-sponsor" element={
            <ProtectedRoute>
              <HeadlineSponsor />
            </ProtectedRoute>
          } />
          
          <Route path="/DlaTrade/sponsor-opportunity" element={
            <ProtectedRoute>
              <SponsorshipOpportunity />
            </ProtectedRoute>
          } />
          
          <Route path="/DlaTrade/trade-awards" element={
            <ProtectedRoute>
              <TradeAwards />
            </ProtectedRoute>
          } />

          {/* A-Z Directory Routes */}
          <Route path="/DlaTrade/az-affiliates" element={
            <ProtectedRoute>
              <AZDirectory />
            </ProtectedRoute>
          } />
          
          <Route path="DlaTrade/become-affiliate-member" element={
            <ProtectedRoute>
              <BecomeAffiliateMember />
            </ProtectedRoute>
          } />
          
          <Route path="/About-Dla/OurPolicies" element={
            <ProtectedRoute>
              <OurPolicies />
            </ProtectedRoute>
          } />
          
          <Route path="/About-Dla/OurPolicies/:policySlug" element={
            <ProtectedRoute>
              <PolicyDetail />
            </ProtectedRoute>
          } />
          
          <Route path="/About-Dla/OurPolicies/:policySlug/items/:itemSlug" element={
            <ProtectedRoute>
              <ItemDetail />
            </ProtectedRoute>
          } />
                   {/* CONTENT DETAIL PAGE ROUTE - When user clicks button with content */}
          <Route path="/About-Dla/BecomeMember/content/:slug" element={
            <ProtectedRoute>
              <ContentDetailPage />
            </ProtectedRoute>
          } />
          
          <Route path="/About-Dla/DLAFellowship" element={
            <ProtectedRoute>
              <DLAFellowship />
            </ProtectedRoute>
          } />
          
          {/* ✅ NEW FELLOWSHIP AWARDS ROUTE */}
          <Route path="/About-Dla/Fellowship/Awards" element={
            <ProtectedRoute>
              <FellowshipAwards />
            </ProtectedRoute>
          } />
       
                 <Route path="/About-Dla/Fellowship/Recognition" element={
               <ProtectedRoute>
                 <SpecialRecognitionAward />
               </ProtectedRoute>
               } />
               <Route path="/About-Dla/BecomeMember" element={
                <ProtectedRoute>
                  <BecomeAMember />
                </ProtectedRoute>
               }/>
               <Route path="/dental-news" element={
                <ProtectedRoute>
                  <DentalNews />
                </ProtectedRoute>
               }/>
               <Route path="/dental-news/:id/posts" element={
                <ProtectedRoute>
                  <DlaNewsPosts />
                </ProtectedRoute>
               }/>
            <Route path="/add-store-cards" element={
                <ProtectedRoute>
                  <AddStoreCards />
                </ProtectedRoute>
               }/>
               <Route path="/dental-news/dentallab-journal" element={
                <ProtectedRoute>
                  <DentallabJournal />
                </ProtectedRoute>
               }/>
               <Route path="/add-members-area" element={
                <ProtectedRoute>
                  <MembersAreaCards/>
                </ProtectedRoute>
               } />
             <Route path="/drap-applications" element={
                <ProtectedRoute>
                  <DRAPApplicationsPage />
                </ProtectedRoute>
               } />
        </RouterRoutes>
      </div>
    </div>
  );
};

export default PanelRoutes;